import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import translations from '../../translations.en.json';
import '@fiverr/i18n/singleton';

import './index.scss';

export const buttons = () => ({
    SHARE: i18n.t('general.share'),
    SEND: i18n.t('sharing_link.button.send')
});

class LargeButton extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);
    }

    render() {
        const { onClick, children, className } = this.props;
        return (
            <button className={classNames('sharing-link-button btn-lrg-standard', className)} onClick={onClick}>
                { children }
            </button>
        );
    }
}

LargeButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default LargeButton;



// WEBPACK FOOTER //
// ./src/components/LargeButton/index.js